import React, { useCallback, useState } from 'react';
import { FeedbackCommentProps, FeedbackSectionId } from './utils';
import { Answer } from './api';
import FeedbackCommentsSection, {
  FeedbackCommentsSectionProps,
} from './FeedbackCommentsSection';
import { ShowIndicatorFeedbackButton } from 'npo/pages/NPOFeedback/MakeEdits/components/ImpactTable/ShowIndicatorFeedback';
import { useUserActions } from 'shared/auth/hooks/useUserActions';

interface FeedbackModelCommentsProps {
  comments: FeedbackCommentProps[];
  reportId: number;
  questionId: number;
  details?: string;
  sectionId: FeedbackSectionId;
  answer: Answer;
  nullFeedbackText?: string;
  hideModelButton?: boolean;
  showButtonText?: string;
  showWrapperClassName?: string;
  commentsWrapperClassName?: string;
  textareaWrapperClassName?: string;
  deleteQuestionLevelComment: FeedbackCommentsSectionProps['deleteQuestionLevelComment'];
  updateQuestionLevelComment: FeedbackCommentsSectionProps['updateQuestionLevelComment'];
  onSuccessDelete: FeedbackCommentsSectionProps['onSuccessDelete'];
  onSuccessSave: FeedbackCommentsSectionProps['onSuccessSave'];
  addOrUpdateComment: FeedbackCommentsSectionProps['addOrUpdateComment'];
}

const FeedbackModelComments: React.FC<FeedbackModelCommentsProps> = ({
  comments,
  reportId,
  questionId,
  details,
  sectionId,
  answer,
  nullFeedbackText,
  hideModelButton,
  showButtonText,
  showWrapperClassName,
  commentsWrapperClassName,
  textareaWrapperClassName,
  deleteQuestionLevelComment,
  updateQuestionLevelComment,
  onSuccessDelete,
  onSuccessSave,
  addOrUpdateComment,
}) => {
  const { userType, email, name } = useUserActions();
  const [open, setOpen] = useState<boolean>(false);

  const handleToggle = useCallback(() => {
    setOpen(o => !o);
  }, [setOpen]);

  return (
    <>
      <ShowIndicatorFeedbackButton
        show={open}
        reverseIcon={true}
        comments={comments}
        feedbackText={showButtonText}
        className={showWrapperClassName}
        nullFeedbackText={nullFeedbackText}
        toggleShow={handleToggle}
      />
      {open && (
        <FeedbackCommentsSection
          comments={comments}
          userType={userType}
          currentUserEmail={email}
          userName={name}
          reportId={reportId}
          questionId={questionId}
          details={details}
          feedbackSectionId={sectionId}
          answer={answer}
          hideModelButton={hideModelButton}
          commentsWrapperClassName={commentsWrapperClassName}
          textareaWrapperClassName={textareaWrapperClassName}
          deleteQuestionLevelComment={deleteQuestionLevelComment}
          updateQuestionLevelComment={updateQuestionLevelComment}
          onSuccessDelete={onSuccessDelete}
          onSuccessSave={onSuccessSave}
          addOrUpdateComment={addOrUpdateComment}
        />
      )}
    </>
  );
};

export default FeedbackModelComments;
